// ENV is defined via webpack DefinePlugin and resolves to one of:
// "local", "dev", "stage", "preview", "prod".
//
// - debug: non-prod only. Prefix + "Silent in prod." + args (PII / verbose QA).
// - info | warn | error: all environments. Prefix + args only (operational / bundle failures).

const LOG_PREFIX = "[account-wrapper]";
const PROD_VISIBILITY_NOTE = "Silent in prod.";
const isProd = typeof ENV !== "undefined" && ENV === "prod";

const emitDev = (consoleFn, ...args) => {
    if (isProd) {
        return;
    }
    consoleFn(LOG_PREFIX, PROD_VISIBILITY_NOTE, ...args);
};

const emitAlways = (consoleFn, ...args) => {
    consoleFn(LOG_PREFIX, ...args);
};

const logger = {
    /** Verbose / sensitive; not emitted when ENV is prod. */
    debug(...args) {
        emitDev(console.log, ...args);
    },
    /** Dev-only channel using console.error (stack traces); not emitted in prod. */
    debugError(...args) {
        emitDev(console.error, ...args);
    },
    /** Emitted in all environments (e.g. version banner). */
    info(...args) {
        emitAlways(console.log, ...args);
    },
    warn(...args) {
        emitAlways(console.warn, ...args);
    },
    error(...args) {
        emitAlways(console.error, ...args);
    },
};

export default logger;
